// extracted by css-extract-rspack-plugin
export default {"moreChartsHeader":"ChartTypeSettings-module__moreChartsHeader___uLK7s"};